
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create/[[...slug]]",
      function () {
        return require("private-next-pages/create/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create/[[...slug]]"])
      });
    }
  